import "./OnboardingCard.css";
import React from "react";
import ContentItem from "shared/components/cms/ContentItem";

export default () => (
    <div className="onboarding-card">
        <h2 className="onboarding-header">Our <span className="highlighted">solutions are simple</span> to implement.</h2>
        <img src={require("../../assets/redesign2020/products/onboarding.svg")} alt="Onboard Gradifi with ease" className="onboarding-image" />
        <div className="onboarding-body">
            <h3 className="onboarding-body-header">Get employees <span className="highlighted">onboarded with ease</span>.</h3>
            <ContentItem tag="p" sharedKey="marketing2020/onboarding" className="onboarding-body-text" contentKey="onboardingBodyText" />
        </div>
    </div>
);